var map = {
	"./icon--arrow-right.svg": 944,
	"./icon--burger.svg": 2289,
	"./icon--close.svg": 9182,
	"./icon--facebook.svg": 326,
	"./icon--instagram.svg": 6562,
	"./icon--linkedin.svg": 5396,
	"./icon--mag-glass.svg": 8596,
	"./icon--mail.svg": 1119,
	"./icon--phone.svg": 8546,
	"./icon--star.svg": 7410,
	"./icon--twitter.svg": 7603,
	"./icon--whatsapp.svg": 1748
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3394;